module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/util/support/isBufferBrowser.js
// module id = PIb/
// module chunks = 6